import { useState, useEffect, Suspense } from "react";
import { getRequest } from "../apiService";
import { useSelector, useDispatch } from "react-redux";
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  useNavigate,
} from "react-router-dom";
import SmartCallList from "../components/home_pg/SmartCallList";
import "../styling/home.scss";


export function Home() {
  const [inputs, setInputs] = useState({});
  const [repeatMockCallList, setRepeatMockCallList] = useState([]);
  //     [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20, 21,22, 23,24,25,26,27,28,29,30]
  // const [name, setName] = useState("");
  // const [result, setResult] = useState("");

  const [dashLinks, setDashLinks] = useState({});
  const apiUrl = useSelector((state) => state.apiUrlPath.value);
  const navigate = useNavigate();

  useEffect(() => {
    getLinks();
  }, []);

  async function getLinks() {
    try {
      const result = await getRequest("menu/getDashLinks");

      if (result.success) {
        setDashLinks(result.data.data);
      } else {
        console.error("Failed to load sections:", result.error);
      }
    } catch (error) {
      console.error("Error loading sections:", error);
    }
  }



  function redirectOnLoad() {
    console.groupCollapsed(
      "Redirecting User based on department and access to different page on login"
    );
    console.log(sessionStorage.getItem("department") === "BSS");
    if (sessionStorage.getItem("department") === "BSS") {
      console.log("true department is " + sessionStorage.getItem("department"));
      console.log("navigate campaign checklist");
      navigate("/campaign-checklist");
    } else if (Number(sessionStorage.getItem("user-accessLevel")) > 3) {
      console.log(
        "true access is higher than team leader and assistant office director granted top dashboard"
      );
      navigate("/od-dashboard");
    } else if (Number(sessionStorage.getItem("user-accessLevel")) <= 3) {
      console.log("access recognized as agent. Redirected to agent dashboard");
      navigate("/agent-dashboard");
    }
    console.groupEnd();
  }

  return (
    <>
      {/* <h1>Home</h1>
      <p>I am text confirming the load of homepage. Woooooooooo!</p> */}
      <div id="homepage">
        <div id="top-section">
          <h1>For You</h1>
          {/* <span className="material-symbols-outlined" title={'Customize homepage'} onClick={()=>alert('functionality being built')}>
                  info
                </span> */}
        </div>
        <div className="scroll-snap-box">
          <div className="modal scroll-snap-el">
            <h2 className="hm-modal-title">Quick Links</h2>
  <div className="quick-links-box">
            {typeof dashLinks !== "undefined" && dashLinks.length > 0
              ? dashLinks.map((x, index) => (
                  <NavLink
                    key={index}
                    to={x.urlPath}
                    className={x.classes}
                    title={"Navigate to " + x.title}
                    replace
                  >
                    <div className={"pgLink-box"}>
                      <h3>{x.title}</h3>
                      <span className="material-symbols-outlined">
                        {x.icon}
                      </span>
                      <p>
                        {typeof x.desc !== "undefined" &&
                        x.desc !== null &&
                        x.desc !== "abc"
                          ? x.desc
                          : "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed laoreet mollis egestas. Donec eleifend scelerisque hendrerit."}
                      </p>
                    </div>
                  </NavLink>
                ))
              : null}
          </div>
          </div>
          <SmartCallList />
        </div>
      </div>
    </>
  );
}

export default Home;
